import React from 'react';
import Card from 'react-bootstrap/Card';
import { Carousel, CarouselCaption, CarouselItem } from 'react-bootstrap';


function CardTableauDeBord() {
  return (
    <>
        <Carousel  style={{width:"99%"}}>
            <CarouselItem >
            <Card.Img variant="top" src="/img/champion.jpg" style={{height:"auto", maxHeight:"680px"}} />
            <CarouselCaption>
                <h3>Amène ton équipe vers la gloire !</h3>
                <p>Découvre les tactiques gagnantes, les joueurs étoiles et domine le terrain !</p>
            </CarouselCaption>
            </CarouselItem>


            <CarouselItem>
            <Card.Img variant="top" src="/img/tableau-de-bord.jpg" style={{height:"auto", maxHeight:"680px"}} />
            <CarouselCaption>
            <h3>Le football pour tous, sans aucune forme de racisme !</h3>
            <p>Peu importe ta couleur de peau, ta religion ou ton origine, le football est un langage universel qui unit les gens.</p>
            </CarouselCaption>
            </CarouselItem>

        </Carousel>
  

    </>
  );
}

export default CardTableauDeBord;